import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import "react-datepicker/dist/react-datepicker.css";
import "./polyfill";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { icons } from "./assets/icons";

import { Provider } from "react-redux";
import configureStore from "./shared/redux/configureStore";
import { BrowserRouter } from "react-router-dom";

React.icons = icons;
const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
